import { render, staticRenderFns } from "./ProductGroupEditNode.vue?vue&type=template&id=4a5c570c&scoped=true"
import script from "./ProductGroupEditNode.vue?vue&type=script&lang=ts"
export * from "./ProductGroupEditNode.vue?vue&type=script&lang=ts"
import style0 from "./ProductGroupEditNode.vue?vue&type=style&index=0&id=4a5c570c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5c570c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a5c570c')) {
      api.createRecord('4a5c570c', component.options)
    } else {
      api.reload('4a5c570c', component.options)
    }
    module.hot.accept("./ProductGroupEditNode.vue?vue&type=template&id=4a5c570c&scoped=true", function () {
      api.rerender('4a5c570c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product-group/ProductGroupEditNode.vue"
export default component.exports